import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type LanTypes, getLanguageCode } from "@src/helpers";

export const KEY = "/api/customer/legalcustomeremploymenttypes";

interface WorkType {
  legalEmploymentTypeCode: string;
  legalEmploymentType: string;
}

const getLegalCustomerEmploymentTypes = async (language: LanTypes) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<{
    data: { legalCustomerEmploymentTypes: WorkType[] };
  }>(KEY, {
    headers: { langcode: languageCode },
  });
  return response.data;
};

export const useLegalCustomerEmploymentTypes = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return useQuery({
    queryKey: [KEY, i18n.language],
    queryFn: () => getLegalCustomerEmploymentTypes(i18n.language as LanTypes),
    onError() {
      navigate(`/${i18n.language}/error`);
    },
    staleTime: Infinity,
  });
};
